import { API_BASE_URL, STORAGE_KEYS } from '@/config/api';
import { apiRequest } from '@/services/api';
import type { ChatHistoryResponse, ChatListResponse, ChatSendRequest } from '../types/chat';

function getAuthHeader(): Record<string, string> {
  const token = localStorage.getItem(STORAGE_KEYS.AUTH_TOKEN);
  return token ? { Authorization: `Bearer ${token}` } : {};
}

export const chatAiService = {
  async listChats(): Promise<ChatListResponse> {
    // Backend esperado: GET /api/chats
    // Observação: API_BASE_URL já inclui /api, então aqui usamos /chats
    return apiRequest<ChatListResponse>('/chats', { method: 'GET' });
  },

  async getChatHistory(sessionId: string): Promise<ChatHistoryResponse> {
    return apiRequest<ChatHistoryResponse>(`/chat/${encodeURIComponent(sessionId)}`, { method: 'GET' });
  },

  /**
   * POST /api/chat com suporte a streaming/SSE.
   * Retorna o Response para leitura via ReadableStream no composable.
   */
  async sendMessageStream(payload: ChatSendRequest, signal?: AbortSignal): Promise<Response> {
    const response = await fetch(`${API_BASE_URL}/chat`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...getAuthHeader(),
      },
      body: JSON.stringify(payload),
      signal,
    });

    if (!response.ok) {
      const text = await response.text().catch(() => '');
      throw new Error(text || `Erro ao enviar mensagem (${response.status})`);
    }

    return response;
  },
};

